<template>
	<div>
		<!-- 加盟弹窗 -->
		<el-dialog width="356px" :visible.sync="show" :append-to-body="true" @close="close()" @open="open()" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="join_dialog_box">
				<div class="join_dialog_top_box">
					<div class="join_dialog_top">
						<div class="join_dialog_top_title">
							Affiliate
						</div>
						<div class="join_dialog_top_close">
							<img @click="close" class="join_dialog_top_close_icon"
								src="../../../assets/icons/close_icon2.png" alt="" />
						</div>
					</div>
					<div class="join_dialog_top_tab_box">
						<div class="join_dialog_top_tab">
							<div v-for="item in tabList" class="join_dialog_top_tab_item "
								:class="item.id==curTab?'join_dialog_top_tab_item_h':''" @click="clickTab(item)">
								{{item.name}}
							</div>
						</div>
					</div>
				</div>

				<div class="joind_nav" v-if="joindNavShow">
					<img @click="joind2Type=0;joindNavShow=false" class="joind_nav_back_icon"
						src="@/assets/icons/back_icon.png" alt="" />
					<div>
						{{joindNavTitle}}
					</div>
				</div>

				<div ref="contentBox" class="join_dialog_content hide_scroll_bars">
					<div v-if="curTab==1">
						<img @click="clickTab(tabList[1])" class="join_dialog_img1 cursor" src="@/assets/icons/InviteAndEarnBg.png" alt="" />
						<div v-if="true" class="join_dialog_partners_box">
							<div class="join_dialog_partners_title">
								How commissions work
							</div>
							<img class="join_dialog_img1" src="@/assets/icons/aboutImg1.png" alt="" />
							<div class="join_dialog_partners_remark">
								You can get a certain percentage of commission <br>
								from all bet amounts of A, B and C. Please refer to <br>
								the illustrations below to see said rewards.
							</div>
						</div>

						<div v-if="true" class="join_dialog_reward">
							<div class="join_dialog_reward_title">
								Referral Rewards
							</div>
							<div class="join_dialog_reward_item" v-for="item in rewardList" :key="item.name">
								<div class="join_dialog_reward_item_info">
									<div class="join_dialog_reward_item_title">
										{{item.name}}
									</div>
									<div class="join_dialog_reward_item_remark">
										<p>{{item.remark1}}</p>
										<p>{{item.remark2}}</p>
										<p>{{item.remark3}}</p>
									</div>
								</div>
								<img class="join_dialog_reward_item_icon" :class="item.iconClass"
									:src="require(`@/assets/icons/${item.icon}.png`) " alt="" />
							</div>
						</div>

						<div v-if="true" class="join_dialog_partners_box">
							<div class="join_dialog_partners_title">
								How to Level up
							</div>
							<div class="join_dialog_partners_remark">
								You and your invited friends earn points every time <br>
								you place bets or receive rebates. Once your total <br>
								combined activity hits the target, you level up!
							</div>
							<div class="join_dialog_lvlist">
								<div class="join_dialog_lvlist_title">
									<div>
										Level
									</div>
									<div>
										Bet Amount Required
									</div>
								</div>
								<div class="join_dialog_lvlist_item" v-for="(item,index) in lvList" :key="item.id"
									:class="(index+1)%2==0?'bg_1B2027':''">
									<img v-if="item.remark" class="join_dialog_lvlist_item_icon" :src="item.remark"
										alt="" />
									<span v-else>{{item.teamLevel}}</span>
									<div class="join_dialog_lvlist_item_price">
										₦ {{item.teamAmount?item.teamAmount:0}}
									</div>
								</div>
							</div>
							<div class="join_dialog_partners_remark">
								The more you level up, the more you earn in both <br>
								commissions and deposit bonuses
							</div>
						</div>
						<div v-if="true" class="join_dialog_reward">
							<div class="join_dialog_reward_title">
								FAQ
							</div>
							<div class="join_dialog_faq_list">
								<div class="join_dialog_faq_item" v-for="item in setMenuList" :key="item.noticeId"
									@click="item.show = !item.show">
									<div class="join_dialog_faq_top">
										<div class="join_dialog_faq_name">
											{{item.noticeTitle}}
										</div>
										<img v-if="item.show" class="join_dialog_faq_icon"
											src="@/assets/icons/top_icon.png" alt="" />
										<img v-else class="join_dialog_faq_icon" src="@/assets/icons/bottom_icon.png"
											alt="" />
									</div>
									<div v-if="item.show" class="join_dialog_faq_content">
										<div v-html="item.noticeContent"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="curTab==2">
						<div v-if="joind2Type==0">
							<div v-if="true" class="joind2_user">
								<div class="joind2_user_top">
									<div class="joind2_user_avatar_box">
										<img class="joind2_user_avatar" :src="user.avatar" alt="" />
									</div>
									<div class="joind2_user_name">
										<div class="">
											{{user.nickName}}
										</div>
										<div class="joind2_user_id">
											User ID:{{user.userId}}
											<img @click="$use.onCopy(user.userId)" class="joind2_user_copy_icon"
												src="@/assets/icons/copy_icon3.png" alt="" />
										</div>
									</div>
								</div>
								<!-- @click="clickRewardItem(0,'lv')"  -->
								<div class="joind2_user_bottom">
									<div class="joind2_user_bottom_title">
										<span>
											Affiliate Level:
										</span>
										<span class="joind2_user_bottom_lv">
											LVL {{teamInfo.newUserLevel}}
										</span>
									</div>
									<div class="joind2_user_bottom_solid_box">
										<div class="joind2_user_bottom_solid"
											:style="{width:(teamInfo.newLevel/teamInfo.nextLevel)*100+'%'}">
										</div>
									</div>
									<div class="joind2_user_bottom_title" style="text-align: right;">
										<span>Bet amount required: </span>
										<span class="joind2_user_bottom_lv">
											 ₦{{teamInfo.nextLevel}}
										</span>
									</div>
								</div>
							</div>

							<div v-if="true" class="joind2_user_total">
								<div class="joind2_user_total_item">
									<img class="joind2_user_total_item_icon" src="@/assets/icons/jbIcon.png" alt="" />
									<div class="joind2_user_total_item_title">
										Total Rewards
									</div>
									<div class="joind2_user_total_item_num">
										 ₦{{teamInfo.totalRewards}}
									</div>
								</div>
								<div class="joind2_user_total_item">
									<img class="joind2_user_total_item_icon" src="@/assets/icons/rsIcon.png" alt="" />
									<div class="joind2_user_total_item_title">
										Total Referrals
									</div>
									<div class="joind2_user_total_item_num">
										{{teamInfo.totalFriends}}
									</div>
								</div>
							</div>

							<div v-if="true">
								<div class="join_dialog_reward">
									<div class="join_dialog_reward_title">
										My Rewards
									</div>
								</div>
								<div class="joind2_reward">
									<div class="joind2_reward_item cursor" v-for="(item,index) in rewardList"
										:key="item.name2" @click="clickRewardItem(index,item)"
										:class="`${(index+1)%2===0?'mar_r0':''} ${item.itemClass2}`">
										<div class="joind2_reward_item_icon_box">
											<img class="joind2_reward_item_icon" :class="item.iconClass2"
												:src="require(`@/assets/icons/${item.icon}.png`) " alt="" />
										</div>
										<div class="joind2_reward_item_name">
											{{item.name2}}
										</div>
										<div class="joind2_reward_item_btn">
											See Details
										</div>
									</div>
								</div>
							</div>

							<div class="joind2_invite">
								<div class="joind2_invite_title">
									Invite Friends & Earn More!
								</div>
								<div class="joind2_invite_title2">
									Multiple referral promos are active-enjoy:
								</div>
								<div v-if="true" class="joind2_invite_list">
									<div class="joind2_invite_list_item" v-for="(item,index) in inviteList"
										:key="item.id">
										{{index+1}}. {{item.name}}
									</div>
								</div>

								<div class="joind2_invite_input">
									<div class="joind2_invite_input_item">
										<div class="joind2_invite_input_label">
											Link
										</div>
										<div class="joind2_invite_input_name text_ovf">
											{{$shareUrl}}
										</div>
										<div class="joind2_invite_input_btn"
											 @click="$use.copy(`${$shareUrl}/${user.userCode}`)"
										>
											<img class="joind2_invite_input_btn_icon"
												src="@/assets/icons/copy_icon2.png" alt="" />
											Copy
										</div>
									</div>
									<div class="joind2_invite_input_item">
										<div class="joind2_invite_input_label">
											Code
										</div>
										<div class="joind2_invite_input_name">
											{{user.userCode}}
										</div>
										<div @click="$use.copy(user.userCode)"  class="joind2_invite_input_btn">
											<img class="joind2_invite_input_btn_icon"
												src="@/assets/icons/copy_icon2.png" alt="" />
											Copy
										</div>
									</div>
								</div>
								<div class="joind2_share">
									<div class="joind2_share_title">
										Share via your socials
									</div>
									<div class="joind2_share_list">
										<div class="joind2_share_item" @click="clickShare(item)" v-for="item in shareList" :key="item.id">
											<img class="joind2_share_item_icon"	:src="item.mediaIcon" alt="" />
										</div>
									</div>
								</div>
							</div>
						</div>

						<div  ref="joind2Type" v-else-if="joind2Type==2">
							<div class="joind2_commission">
								<div v-if="true" class="joind2_commission_top">
									<div class="joind2_commission_top_title">
										<div>
											Total Available Commission
										</div>
										<img class="joind3_faq_icon" src="@/assets/icons/faq_icon.png" alt="" />
									</div>
									<div class="joind2_commission_top_num">
										₦{{depositCommission.totalPush?depositCommission.totalPush:0}}
									</div>
								</div>
								<div v-if="true" class="joind2_commission_list">
									<div class="joind2_commission_item">
										<div class="joind2_commission_item_title">
											Direct Referral Commission
										</div>
										<div class="joind2_commission_item_num">
											₦{{depositCommission.directPush?depositCommission.directPush:0}}
										</div>
									</div>
									<div class="joind2_commission_item">
										<div class="joind2_commission_item_title">
											Indirect Referral Commission
										</div>
										<div class="joind2_commission_item_num">
											₦{{depositCommission.interPush?depositCommission.interPush:0}}
										</div>
									</div>
									<div class="flex_ac_sb">
										<div></div>
										<div @click="receiveDepositRewards()" class="joind2_deposit_btn opacity1"
											:class="depositCommission.totalPush>0?'':'bg_c5c5c5'">
											Claim
										</div>
									</div>
								</div>
								<div class="joind2_commission_table_box">
									<div class="joind2_commission_table_title">
										Commission History
									</div>
									<div class="joind2_commission_table_select_box">
										<el-date-picker @change="changeTime" class="joind4_history_time" v-model="time"
											type="daterange" range-separator="-" start-placeholder="start Time"
											end-placeholder="end Time">
										</el-date-picker>
									</div>
									<div class="joind2_commission_table_select_box">
										<div class="joind2_commission_table_input" style="width: 100%;">
											<el-input clearable  placeholder="Search Username"
												prefix-icon="el-icon-search" v-model="historyParams.userName"
												@keyup.enter.native="getDepositHistory()">
											</el-input>
										</div>
									</div>

									<div class="joind2_commission_table">
										<div class="joind2_commission_table_top">
											<div class="">
												Username
											</div>
											<div class="">
												Commission
											</div>
										</div>
										<div v-if="historyList.length>0" class="joind2_commission_table_list">
											<div class="joind2_commission_table_item" v-for="item in historyList"
												:key="item.detailId">
												<div class="">
													<div v-if="item.userVo&&item.userVo.nickName">
														{{item.userVo.nickName}}
													</div>
												</div>
												<div class="">
													{{convertUTCTime(item.createTime)}}
												</div>
												<div class="">
													₦{{item.balance?item.balance:0}}
												</div>
											</div>
										</div>
										<div v-if="historyList.length>0" class="flex_as_c">
											<el-pagination background layout="prev, pager, next"
												:page-size="historyParams.pageSize" :total="historyTotal"
												@current-change="changePageNum">
											</el-pagination>
										</div>
										<div v-else class="flex_as_c mar_t15">
											<img class="" src="../../../assets/icons/rsIcon.png" alt="" />
										</div>
									</div>

								</div>

							</div>
						</div>

						<div ref="joind2Type" v-else-if="joind2Type==3">
							<div class="joind2_commission">
								<div v-if="true" class="joind2_commission_top ">
									<div class="joind2_commission_top_title">
										<div>
											<div class="joind2_commission_top_num font_20">
												₦{{teamInfo.totalRewards?teamInfo.totalRewards:0}}
											</div>
											<div class="font_12">
												Total Betting Commission
											</div>
										</div>
										<!-- <div class="joind2_deposit_btn opacity1">
											Claim
										</div> -->
									</div>
									<div class="joind2_commission_top_title mar_t15">
										<div>
											<div class="joind2_commission_top_num font_20 flex_ac_sb">
												<div
													v-if="teamInfo.newUserLevelTeam&&teamInfo.newUserLevelTeam.teamBettingOne">
													{{(+teamInfo.newUserLevelTeam.teamBettingOne)}}%
												</div>
												<div v-else>
													0%
												</div>
												<img class="joind3_faq_icon" src="@/assets/icons/faq_icon.png" alt="" />
											</div>
											<div class="font_12">
												Commission percentage
											</div>
										</div>
									</div>
								</div>


								<div v-if="true" class="joind2_commission_list">
									<div class="joind3_invite">
										<div class="joind2_invite_title">
											Invite Friends & Earn More!
										</div>
										<div class="joind3_invite_remark font_12">
											Share your link, get rewarded! the more friends the <br>
											more percentage commission you stand to get
										</div>
									</div>
									<div class="joind2_invite_input">
										<div class="joind2_invite_input_item">
											<div class="joind2_invite_input_label">
												Link
											</div>
											<div class="joind2_invite_input_name text_ovf">
												{{$shareUrl}}
											</div>
											<div  @click="$use.copy(`${$shareUrl}/${user.userCode}`)" class="joind2_invite_input_btn">
												<img class="joind2_invite_input_btn_icon"
													src="@/assets/icons/copy_icon2.png" alt="" />
												Copy
											</div>
										</div>
										<div class="joind2_invite_input_item">
											<div class="joind2_invite_input_label">
												Code
											</div>
											<div class="joind2_invite_input_name">
												{{user.userCode}}
											</div>
											<div @click="$use.copy(user.userCode)" class="joind2_invite_input_btn">
												<img class="joind2_invite_input_btn_icon"
													src="@/assets/icons/copy_icon2.png" alt="" />
												Copy
											</div>
										</div>
									</div>

								</div>

								<div class="joind2_commission_table_box">
									<div class="joind2_commission_table_title">
										Commission History
									</div>
									<div class="joind2_commission_table_select_box">
										<el-date-picker @change="changeTime" class="joind4_history_time" v-model="time"
											type="daterange" range-separator="-" start-placeholder="start Time"
											end-placeholder="end Time">
										</el-date-picker>
									</div>
									<div class="joind2_commission_table_select_box">
										<div class="joind2_commission_table_input" style="width: 100%;">
											<el-input clearable  placeholder="Search Username"
												prefix-icon="el-icon-search" v-model="historyParams.userName"
												@keyup.enter.native="getDepositHistory()">
											</el-input>
										</div>
									</div>

									<div class="joind2_commission_table">
										<div class="joind2_commission_table_top">
											<div class="">
												Username
											</div>
											<div class="">
												Commission
											</div>
										</div>
										<div v-if="historyList.length>0" class="joind2_commission_table_list">
											<div class="joind2_commission_table_item" v-for="item in historyList"
												:key="item.detailId">
												<div class="">
													<div v-if="item.userVo&&item.userVo.nickName">
														{{item.userVo.nickName}}
													</div>
												</div>
												<div class="">
													{{convertUTCTime(item.createTime)}}
												</div>
												<div class="">
													₦{{item.balance?item.balance:0}}
												</div>
											</div>
										</div>
										<div v-if="historyList.length>0" class="flex_as_c">
											<el-pagination background layout="prev, pager, next"
												:page-size="historyParams.pageSize" :total="historyTotal"
												@current-change="changePageNum">
											</el-pagination>
										</div>
										<div v-else class="flex_as_c mar_t15"  style="height: 300px;">
											<img class="" src="../../../assets/icons/rsIcon.png" alt="" />
										</div>
									</div>
								</div>

							</div>
						</div>


						<div ref="joind2Type" v-else-if="joind2Type==4">
							<div class="joind2_deposit_list" v-if="historyList.length>0">
								<div class="joind2_deposit_list_item" v-for="item in historyList">
									<img class="joind2_deposit_list_item_n_icon2" src="@/assets/icons/n_icon2.png"
										alt="" />
									<!-- <img v-if="item.userVo" class="joind2_deposit_list_item_n_icon2" :src="item.userVo.avatar"
										alt="" /> -->
									<div class="joind2_deposit_list_item_info">
										<div class="joind2_deposit_list_item_title">
											Earn Deposit cashback of
										</div>
										<div class="joind2_deposit_list_item_num">
											₦{{item.balance?item.balance:0}}
										</div>
									</div>
									<div class="joind2_deposit_list_item_right">
										<div>
											Deposit requirement
										</div>
										<div>
											₦3000
										</div>
									</div>
								</div>
								<!-- <div class="joind2_deposit_list_item bor_no">
									<div class="joind2_deposit_list_item_info">
										<div class="joind2_deposit_list_item_title">
											Earned Cashback
										</div>
										<div class="joind2_deposit_list_item_num">
											₦0
										</div>
									</div>
									<div class="joind2_deposit_btn" :class="false?'opacity1':''">
										Claim
									</div>
								</div> -->
							</div>
							<div v-if="historyList.length>0" class="flex_as_c">
								<el-pagination background layout="prev, pager, next" :page-size="historyParams.pageSize"
									:total="historyTotal" @current-change="changePageNum">
								</el-pagination>
							</div>
							<div v-else class="flex_as_c mar_t15" style="height: 300px;">
								<img class="" src="../../../assets/icons/rsIcon.png" alt="" />
							</div>
						</div>
						<div v-if="joind2Type==0||joind2Type==4" class="join_dialog_reward">
							<div class="join_dialog_reward_title">
								FAQ
							</div>
							<div class="join_dialog_faq_list">
								<div class="join_dialog_faq_item" v-for="item in setMenuList" :key="item.noticeId"
									@click="item.show = !item.show">
									<div class="join_dialog_faq_top">
										<div class="join_dialog_faq_name">
											{{item.noticeTitle}}
										</div>
										<img v-if="item.show" class="join_dialog_faq_icon"
											src="@/assets/icons/top_icon.png" alt="" />
										<img v-else class="join_dialog_faq_icon" src="@/assets/icons/bottom_icon.png"
											alt="" />
									</div>
									<div v-if="item.show" class="join_dialog_faq_content">
										<div v-html="item.noticeContent"></div>
									</div>
								</div>
							</div>
						</div>
					</div>





					<div v-if="curTab==3">
						<div v-if="joind2Type!=5">
							<div v-if="true" class="joind3_price">
								<div class="joind3_price_top">
									<div class="joind3_price_title">
										<div>Total Commission Earned</div>
										<img class="joind3_faq_icon" src="@/assets/icons/faq_icon.png" alt="" />
									</div>
									<div @click="clickRewardItem(4,{name:'Earning History'})"
										class="joind3_price_history cursor">
										<div>Earning History</div>
										<img class="joind3_right_icon" src="@/assets/icons/user_right.png" alt="" />
									</div>
								</div>
								<div class="joind3_price_num">
									₦{{myRecords.totalCommission?myRecords.totalCommission:0}}
								</div>
								<!-- <div class="joind3_price_time">
									(Joined 12/09/2024)
								</div> -->
							</div>
							<div class="joind3_list">
								<div class="joind3_item" v-for="(item,index) in joind3List" :key="item.id"
									:class="`${(index+1)%2===0?'mar_r0':''} `">
									<div class="joind3_item_top">
										<div>
											{{item.name}}
										</div>
										<img class="joind3_faq_icon" src="@/assets/icons/faq_icon.png" alt="" />
									</div>
									<div class="joind3_item_content">
										{{item.content}}
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="joind4_history">
								<el-date-picker @change="changeTime" class="joind4_history_time" v-model="time"
									type="daterange" range-separator="-" start-placeholder="start Time"
									end-placeholder="end Time">
								</el-date-picker>
								
								<div>
									<div class="joind4_history_list" style="min-height: 300px;" v-if="historyList.length>0">
										<div class="joind4_history_item" v-for="item in historyList"
											:key="item.detailId">
											<img class="joind4_history_item_n_icon2" src="@/assets/icons/n_icon2.png"
												alt="" />
											<div class="joind4_history_item_info">
												<div class="joind4_history_item_title">
													{{item.dateFormat}}
												</div>
											</div>
											<div class="joind4_history_item_right">
												₦{{item.balance?item.balance:0}}
											</div>
										</div>
									</div>
									<div v-if="historyList.length>0" class="flex_as_c mar_t10">
										<el-pagination background layout="prev, pager, next"
											:page-size="historyParams.pageSize" :total="historyTotal"
											@current-change="changePageNum">
										</el-pagination>
									</div>
									<div v-else class="flex_as_c mar_t15" style="height: 300px;">
										<img class="" src="../../../assets/icons/rsIcon.png" alt="" />
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>


		<el-dialog width="284px" :visible.sync="invDialgShow" @close="invDialgShow=false" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="doind1_invdialg">
				<img @click="invDialgShow=false" class="doind1_close_icon" src="@/assets/icons/close_icon.png" alt="" />

				<div class="doind1_invdialg_title">
					<span v-if="invDialgType==1">
						<!-- 邀请奖励 -->
						Invitation Rewards
					</span>
					<span v-else-if="invDialgType==2">
						<!-- 邀请等级 -->
						Invitation Rewards
					</span>
				</div>
				<div class="doind1_invdialg_title2">
					<span v-if="invDialgType==1">
						<!-- 邀请奖励 -->
						Congratulations!
					</span>
					<span v-else-if="invDialgType==2">
						<!-- 邀请等级 -->
						Affiliate level 2 unlocked!
					</span>
				</div>

				<div v-if="invDialgType==1">
					<div class="doind1_invdialg_num">
						{{teamInfo.invitationRewards||0}}
					</div>
					<div class="doind1_invdialg_title3">
						Total Friends Invited:{{teamInfo.totalFriends}}
					</div>
				</div>
				<div v-else-if="invDialgType==2">
					<div class="doind1_invdialg_lv_icon_box">
						<img @click="invDialgShow=false" class="doind1_invdialg_lv_icon1"
							src="@/assets/icons/lv_icon1.png" alt="" />
						<img @click="invDialgShow=false" class="doind1_invdialg_lv_icon2"
							src="@/assets/icons/lv_icon2.png" alt="" />
						<img @click="invDialgShow=false" class="doind1_invdialg_lv_icon_suo"
							src="@/assets/icons/lv_icon_suo.png" alt="" />
					</div>
					<div class="joind2_user_bottom">
						<div class="joind2_user_bottom_title">
							<span>
								Affiliate Level:
							</span>
							<span class="joind2_user_bottom_lv">
								LVL 1
							</span>
						</div>
						<div class="joind2_user_bottom_solid_box">
							<div class="joind2_user_bottom_solid" :style="{width:'50%'}">
							</div>
						</div>
						<div class="joind2_user_bottom_title" style="text-align: right;">
							<span>Bet amount required: </span>
							<span class="joind2_user_bottom_lv">
								 ₦50,000
							</span>
						</div>
					</div>
				</div>

				<div @click="handleContinue" class="doind1_invdialg_btn">
					Continue
				</div>
			</div>
		</el-dialog>


		<el-dialog width="365px" :visible.sync="tipShow" @close="tipShow=false" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="doind1_tip">
				<img @click="tipShow=false" class="doind1_close_icon" src="@/assets/icons/close_icon.png" alt="" />
				<div class="doind1_tip_title">
					Deposit Commission
				</div>
				<div class="doind1_tip_list">
					<div class="doind1_tip_item">
						<div class="doind1_tip_item_title">
							Total Available Commission
						</div>
						<div class="doind1_tip_item_remark">
							All the commission you've earned from people you've <br>
							invited.
						</div>
					</div>
					<div class="doind1_tip_item">
						<div class="doind1_tip_item_title">
							Direct Referral Commission
						</div>
						<div class="doind1_tip_item_remark">
							Commission from friends you invited directly.
						</div>
					</div>
					<div class="doind1_tip_item">
						<div class="doind1_tip_item_title">
							Indirect Referral Commission
						</div>
						<div class="doind1_tip_item_remark">
							Commission from people invited by your friends.
						</div>
					</div>

				</div>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex';
	import moment from'moment-timezone';


	export default {
		name: 'joinDialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
			curTabs:{
				type: Number,
				default: 1
			}
		},
		computed: {
			...mapState(['user', 'token', 'selfType','currentCountry']), // 映射 user 模块下的 userInfo 状态
		},
		data() {
			return {
				teamInfo: {}, //获取推荐等级信息
				setMenuList: [], //常见问题

				curTab: 1,
				tabList: [{
						id: 1,
						name: 'About'
					},
					{
						id: 2,
						name: 'Dashboard'
					},
					{
						id: 3,
						name: 'My Records'
					}
				],
				invDialgShow: false, //邀请奖励弹窗
				invDialgType: 1, //1邀请奖励  2邀请等级
				joind2Type: 0, // tab2页面显示状态 对照rewardList  0主页面 4存款奖励  5=tab3History历史记录

				joindNavShow: false,
				joindNavTitle: 'Deposit Reward',

				select: '', //类别筛选
				selectList: [{
					gameId: '',
					gameName: 'Date Range',
				}, ],
				value: '',

				tipShow: false,




				rewardList: [{
						name: 'Invitation Bonus',
						name2: 'Invitation Rewards', //curTab == 2 使用name2
						remark1: 'Invite friends to join and earn',
						remark2: 'exciting bonuses when they sign',
						remark3: 'up and start using the platform.',
						icon: 'rewards1Img',
						iconClass: '',
						iconClass2: 'joind2_reward_item_icon21',
						itemClass2: 'joind2_reward_item_bg1',
					},
					{
						name: 'Deposit Commission',
						name2: 'Deposit Commission',
						remark1: 'Fund your account and enjoy',
						remark2: 'extra rewards with every',
						remark3: 'qualifying deposit you make.',
						icon: 'rewards2Img',
						iconClass: 'join_dialog_reward_item_icon2',
						iconClass2: 'joind2_reward_item_icon22',
						itemClass2: 'joind2_reward_item_bg2',
					},
					{
						name: 'Betting Commission',
						name2: 'Betting Commission',
						remark1: 'You and your team place bets,',
						remark2: 'grow together, and earn rewarding',
						remark3: 'commissions along the way.',
						icon: 'rewards3Img',
						iconClass: 'join_dialog_reward_item_icon2',
						iconClass2: 'joind2_reward_item_icon23',
						itemClass2: 'joind2_reward_item_bg3',
					},
					{
						name: 'Deposit Reward',
						name2: 'Deposit Rewards',
						remark1: 'Deposit regularly, level up faster,',
						remark2: 'and unlock special rewards for',
						remark3: 'your activity.',
						icon: 'rewards4Img',
						iconClass: 'join_dialog_reward_item_icon4',
						iconClass2: 'joind2_reward_item_icon24',
						itemClass2: 'joind2_reward_item_bg4',
					},
				],
				lvList: [], //等级列表
				inviteList: [{
						id: 1,
						name: 'Commission on their bets',
					},
					{
						id: 2,
						name: 'Friend invitation rewards',
					},
					{
						id: 3,
						name: 'Commission on your referral’s deposits',
					},
					{
						id: 4,
						name: 'Deposit bonuses for both of you',
					}
				],
				shareList: [],
				joind3List: [{
						id: 1,
						name: 'Current Level',
						remark: '',
						content: 'VIP 1',
					},
					{
						id: 3,
						name: 'Downline Members',
						remark: '',
						content: '10',
					},
					{
						id: 4,
						name: 'Earned Commission',
						remark: '',
						content: '₦20,900.00',
					},
					{
						id: 5,
						name: 'Active Members',
						remark: '',
						content: '4',
					},
					{
						id: 6,
						name: 'Withdrawable Comm.',
						remark: '',
						content: '₦2.60',
					},
					// {
					// 	id: 2,
					// 	name: 'Referral  Rate',
					// 	remark: '',
					// 	content: '0.20%',
					// },

				],

				// 历史记录
				time: null,
				historyParams: {
					startTime: '',
					endTime: '',
					pageSize: 10,
					pageNum: 1,
					userName: '',
				},
				historyList: [],
				historyTotal: 0,
				depositCommission: {
					interPush: '',
					directPush: '',
					totalPush: '',
				},


				myRecords: [], // 我的记录信息





			}
		},
		watch: {
			curTabs(val) {
				if (val) {
					this.curTab = val
				}
			}
		},
		mounted() {
			if(localStorage.getItem('token')){
				this.open()
			}
		},
		methods: {
			// 根据不同时区转化时间
			convertUTCTime(utcTimestamp){
				// 获取用户本地时区偏移量（分钟）
				const utcMoment = moment.utc(utcTimestamp);
				const localMoment = utcMoment.tz(this.currentCountry.timezone);
				const formattedTime = localMoment.format('YYYY-MM-DD HH:mm:ss');
				return formattedTime
			},

			open() {
				
				// 获取当前推荐等级信息
				// this.getTeamInfo()
				this.getNoticeList()
				this.getMyRecords()
				this.getMediaList()
			},
			getMediaList(){
				this.$api.getList({}).then(res => {
					this.shareList = res.data
				})
			},
			clickShare(value){
				window.open(value.mediaUrl, '_blank', 'noopener,noreferrer');
			},
			close() {
				this.$emit('close')
			},
			clickTab(item) {
				this.curTab = item.id
				this.joind2Type = 0 // tab2页面显示状态 对照rewardList  0主页面 4存款奖励  5=tab3History历史记录
				this.joindNavShow = false
				this.joindNavTitle = ''
				this.$refs.contentBox.scrollTop = 0;
			},
			clickRewardItem(index, type = null) {

				if (index == 0) {
					if (type == 'lv') {
						this.invDialgType = 2
					} else {
						this.invDialgType = 1
					}
					this.invDialgShow = true
					return
				} else {
					this.$refs.contentBox.joind2Type = 0;
					this.joindNavTitle = type.name
					this.joind2Type = (index + 1)

					this.time = null;
					this.historyParams.startTime = ''
					this.historyParams.endTime = ''
					this.historyParams.pageSize = 10
					this.historyParams.pageNum = 1
					this.historyParams.userName = ''
					this.historyParams.historyList = []
					this.historyParams.historyTotal = 0
					this.getDepositHistory()
					if (index == 1 || index == 3) {
						this.getDepositCommission()
					}
				}

				this.joindNavShow = true
			},
			// 获取当前推荐等级信息
			getTeamInfo() {
				this.$api.teamInfo({}).then(res => {
					this.teamInfo = res.data
					this.lvList = res.data.team
				})
			},
			// 我的记录信息
			getMyRecords() {
				this.$api.myRecords({}).then(res => {
					this.myRecords = res.data
					this.joind3List[0].content = res.data.newUserLevel
					this.joind3List[1].content = res.data.downFriends
					this.joind3List[2].content = res.data.recommendRewards
					this.joind3List[3].content = res.data.activeFriends
					this.joind3List[4].content = res.data.depositRewards || 0
				})
			},
			// 选中筛选枚举
			changeSelect(e) {

			},
			// 选中查询日期
			changeTime(e) {
				this.historyParams.startTime = this.$use.fromDate(e[0])
				this.historyParams.endTime = this.$use.fromDate(e[1])
				this.getDepositHistory()
			},
			// 获取存款佣金记录
			getDepositHistory() {
				let apiName = 'depositHistory'
				if (this.joind2Type == 3) {
					apiName = 'bettingReferralPlanList'
				} else if (this.joind2Type == 5) {
					apiName = 'invitationHistory'
				}
				this.$api[apiName](this.historyParams).then(res => {
					this.historyList = res.rows
					this.historyTotal = res.total
				})
			},
			changePageNum(e) {
				this.historyParams.pageNum = e
				this.getDepositHistory()
			},
			// 获取存款佣金直推间推金额
			getDepositCommission() {
				this.$api.depositCommission({}).then(res => {
					this.depositCommission = res.data
				})
			},
			// 领取存款佣金直推间推金额
			receiveDepositRewards() {
				if (this.depositCommission.totalPush > 0) {
					this.$api.receiveDepositRewards({}).then(res => {
						this.$use.msg('Received successfully', 'success')
						this.getDepositCommission()
						this.$store.dispatch('GetInfo')
					})
				}
			},

			// 常见问题
			getNoticeList() {
				this.$api.noticeList({
					type: 6
				}).then(res => {
					if (res.data.length > 0) {
						res.data.forEach(item => {
							item.show = false
						})
						this.setMenuList = res.data
					}

				})
			},
			handleContinue(){
				this.invDialgShow=false
				this.$store.dispatch('GetInfo')
			}





		},
	}
</script>

<style lang="scss">
	.joind2_commission_table_select_box {
		.el-input__inner {
			height: 46px !important;
			background: #161A22 !important;
			border: none !important;
			font-size: 10px;
			color: #667182 !important;
			border-radius: 11px !important;
		}
	}

	.joind2_commission_table_select {
		.el-input__inner {
			background: none !important;
			font-size: 10px;
			color: #B0C3E3;
			border: none !important;
		}
	}


	.joind4_history {
		.el-input__inner {
			height: 46px !important;
			background: #161A22 !important;
			border: none !important;
			font-size: 10px;
			color: #667182 !important;
			border-radius: 11px !important;
		}
	}
</style>
<style scoped lang="scss">
	@import url('scss/joinDialog.scss');
</style>